import { css } from "@compiled/react";

import { RoadmapFeature } from "../types.ts";

export interface FeatureDescriptionProps {
    content: RoadmapFeature["description"];
}

export const FeatureDescription = (props: FeatureDescriptionProps) => {
    // todo: GWP-9601
    return (
        <p
            // p tags have inherent margin, so we need to reset it 🫠
            css={css({
                marginBlockStart: 0
            })}
        >
            {props.content.json.content[0]?.content[0]?.value}
        </p>
    );
};
